import { TDOId } from '@common-modules/universal/models/Brands';
import { StructuredDataObject } from './StructuredDataObject';
import { SummaryTDO } from './SummaryTDO';

export const CREATED_DATE = 'created_date';
export const LAST_MODIFIED_DATE = 'last_modified_date';

export interface MainPageStore {
  readonly sdos: { readonly [id: string]: StructuredDataObject };
  readonly tdos: { readonly [id: string]: SummaryTDO };
  readonly selectedTDOs: { readonly [id: TDOId]: boolean };
  readonly currentPage: number;
  readonly itemsPerPage: number;
  readonly hasMore: boolean;
  readonly loadingNextPage: boolean;
  readonly invalidSDOCount: number;
  // VE-24955: high-water mark of how many raw SDO records the server has
  // returned for the current list. Pagination pages against this, not the store
  // size, because trashed/invalid SDOs are dropped from the store after fetch —
  // using the store size as the offset re-requests the same rows forever.
  readonly sdoOffset: number;
  /**
   * Date sort keys, a well-known redaction status filter, or a custom status
   * label stored on the TDO tag (VE-24546).
   */
  readonly filter: string;
  readonly fetchingOrganizationTdos: boolean;
  readonly loaded: boolean;
  readonly isFilePickerOpen: boolean;
  readonly isFilePickerUrlOpen: boolean;
  readonly error?: string;
  readonly listTDOsUploading: { readonly [id: string]: boolean };
  // VE-23391: TDO ids uploaded during this session — flagged with a "New" pill
  // in the grid. Session-scoped (clears on reload).
  readonly newlyAddedTdoIds: string[];
  // VE-24901: the TDO the user most recently opened (navigation) — flagged with
  // a "Last Opened" pill in the grid, mirroring the folder view. Session-scoped
  // (clears on reload); a single id since the legacy grid is a flat org list.
  readonly lastOpenedTdoId?: string;
  // VE-26729: set when something off the Home route changed what Home should show —
  // today, restoring files or folders out of Trash. Home used to pick those changes up
  // only because the nav drawer hard-reloaded the browser; now that it navigates in-app
  // (and the Home route saga is preserved across the switch, so its start-up fetches do
  // not re-fire), the refresh has to be asked for explicitly. Consumed and cleared by
  // initMainPage's ROUTE_HOME watcher.
  readonly homeListStale: boolean;
}
